export default __webpack_public_path__ + "static/media/familyMember.70cabb48.svg";